import { cn } from '@/lib/css-utils'

export function DetailNote({
  title,
  children,
  className,
}: {
  title: string
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn('px-4 text-sm text-copy-primary', className)}>
      <h3 className="font-semibold mb-2">{title}</h3>
      <p className="text-copy-muted whitespace-break-spaces">{children}</p>
    </div>
  )
}
